export const FILTER_ACTION = {
    ADD: 'Add',
    REMOVE: 'Remove',
} as const;

export const getFilterAction = (
    added: string[] = [],
    removed: string[] = []
) => {
    if (added.length && !removed.length) {
        return FILTER_ACTION.ADD;
    }
    if (!added.length && removed.length) {
        return FILTER_ACTION.REMOVE;
    }
    return `${FILTER_ACTION.ADD} & ${FILTER_ACTION.REMOVE}` as const;
};
